import { render, staticRenderFns } from "./HistoriesTimeline.vue?vue&type=template&id=6a980d12&scoped=true&"
import script from "./HistoriesTimeline.vue?vue&type=script&lang=js&"
export * from "./HistoriesTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a980d12",
  null
  
)

export default component.exports